import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { fetchUserProfile } from '../../api/profile';
import LoadingSpinner from '../../components/common/Loader';

const AuthProtectedRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);
  const [isVerified, setIsVerified] = useState(null);
  const location = useLocation();

  // console.log('Rendering AuthProtectedRoute');
  // console.log('User:', user);
  // console.log('Loading:', loading);
  // console.log('isVerified:', isVerified);
  // console.log('Current Path:', location.pathname);

  useEffect(() => {
    const checkVerification = async () => {
      if (user) {
        try {
          const userInfo = await fetchUserProfile(user.user_id);
       //   console.log('User verification status:', userInfo.user.is_verified);
          setIsVerified(userInfo.user.is_verified);
        } catch (error) {
          console.error('Error fetching user profile:', error);
        }
      }
    };

    checkVerification();
  }, [user]); // Run this effect when `user` changes

  if (loading) {
   // console.log('Loading: Showing spinner');
    return <LoadingSpinner />;
  }

  if (!user) {
  //  console.log('User not logged in: Redirecting to login');
    return <Navigate to="/login" />;
  }

 
  return children;
};

export default AuthProtectedRoute;
